import { cn } from "@/lib/utils";

import { useCartItemContext } from "./CartItem.context";
import CartItemLink from "./CartItemLink";

type CartItemNameProps = {
  className?: string;
};

const CartItemName = ({ className }: CartItemNameProps) => {
  const { item, locale } = useCartItemContext();

  if (!item) return null;

  return (
    <div
      className={cn(
        "flex w-full flex-col gap-1 self-start overflow-hidden",
        className,
      )}
    >
      {item.extras?.brand && (
        <span className="all-small-caps text-sm uppercase tracking-wider">
          {item.extras.brand}
        </span>
      )}
      <CartItemLink
        className="flex flex-col overflow-hidden"
        slug={item.extras?.product_url}
        locale={locale}
      >
        {item.name && <span className="truncate text-lg">{item.name}</span>}
      </CartItemLink>
    </div>
  );
};

CartItemName.displayName = "CartItemName";

export default CartItemName;
